module.exports = __webpack_public_path__ + "static/img/200198.308c51db.png";